import React from 'react';
import FacebookIcon from '@material-ui/icons/Facebook';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import GitHubIcon from '@material-ui/icons/GitHub';
import { Button } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';

const SliderInfo = () => {
    return (
        <div className="container slider_sub_container">
            <div className="container slider_sub_aria">
                <div className='flex w-max mb-3 overflow-visible'>
                    <a href="https://www.facebook.com/mdtajuuddintarek/" target='_blank' rel='noreferrer'>
                        <IconButton className="footer_icon_area">
                            <FacebookIcon className='footer_icon' />
                        </IconButton>
                    </a>
                    <a href="https://www.linkedin.com/in/mdtajuuddintarek/" target='_blank' rel='noreferrer'>
                        <IconButton className="footer_icon_area">
                            <LinkedInIcon className='footer_icon' />
                        </IconButton>
                    </a>
                    <a href="https://github.com/mdtaju" target='_blank' rel='noreferrer'>
                        <IconButton className="footer_icon_area">
                            <GitHubIcon className='footer_icon' />
                        </IconButton>
                    </a>
                </div>
                <h1 className='text-xl mb-3 font-semibold'>Hello, My name is</h1>
                <h1 className='text-4xl md:text-5xl font-bold mb-3'>Md. Tajuuddin Tarek</h1>
                <h1 className='mb-4 text-2xl md:text-3xl font-bold'>And I'm a <span className='element slider_self_ind'></span></h1>
                <a href="#contact"><Button className='slider_btn'>Hire Me</Button></a>
            </div>
        </div>
    );
};

export default SliderInfo;